<template>
  <div class="events-list-item">
    <v-hover :close-delay='250' v-slot:default='{hover}'>
      <v-card :class='`transition-fast-in-fast-out pl-${hover ? 5 : 0}`' flat>
        <v-list-item :key='name'>
          <v-row wrap>
            <v-tooltip top>
              <template v-slot:activator='{on}' v-if="type === '3x3'"><v-list-item-avatar v-on='on' tile size='50'><img src='../../assets/333.png'></v-list-item-avatar></template>
              <template v-else-if="type === '3BLD'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../../assets/333bld.png'></v-list-item-avatar></template>
              <template v-else-if="type === '3x3OH'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../../assets/333oh.png'></v-list-item-avatar></template>
              <template v-else-if="type === '2x2'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../../assets/222.png'></v-list-item-avatar></template>
              <template v-else-if="type === '4x4'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../../assets/444.png'></v-list-item-avatar></template>
              <template v-else-if="type === '5x5'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../../assets/555.png'></v-list-item-avatar></template>
              <template v-else-if="type === '6x6'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../../assets/666.png'></v-list-item-avatar></template>
              <template v-else-if="type === '7x7'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../../assets/777.png'></v-list-item-avatar></template>
              <template v-else-if="type === 'Megaminx'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../../assets/minx.png'></v-list-item-avatar></template>
              <template v-else-if="type === 'Pyraminx'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../../assets/pyram.png'></v-list-item-avatar></template>
              <template v-else-if="type === 'Clock'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../../assets/clock.png'></v-list-item-avatar></template>
              <template v-else-if="type === 'Skewb'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../../assets/skewb.png'></v-list-item-avatar></template>
              <template v-else-if="type === 'Square-1'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../../assets/sq1.png'></v-list-item-avatar></template>
              <template v-else-if="type === 'FTO'" v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../../assets/fto.png'></v-list-item-avatar></template>
              <template v-else v-slot:activator='{on}'><v-list-item-avatar v-on='on' tile size='50'><img src='../../assets/invalid.png'></v-list-item-avatar></template>
              <span>{{ type }}</span>
            </v-tooltip>
            <v-col cols='9' sm='5' align-self='center'>
              <v-list-item-content>
                <v-list-item-title>{{ name }} {{roundNameSuffix}}</v-list-item-title>
              </v-list-item-content>
            </v-col>
            <v-col cols='6' sm='5' style='text-align: left'>
              <confirm ref='confirm'></confirm>
              <v-btn v-if="roundType!=='CLOSED' && roundType!=='REGISTERED'" :disabled='cannotRegister' text color='primary' @click='registerEvent'><v-icon small>fa-plus</v-icon>&nbsp;&nbsp;Register</v-btn>
              <v-btn v-if="roundType==='CLOSED' || roundType==='ONGOING'" text color='black' @click='goEvent(false)'><v-icon small>fas fa-arrow-right</v-icon>&nbsp;&nbsp;Results</v-btn>
              <v-btn v-if="roundType==='REGISTERED'" :disabled="status!=='OPEN'" text color='green' @click='competeRound'><v-icon small>fas fa-arrow-right</v-icon>&nbsp;&nbsp;Compete</v-btn>
              <video-link-dialog :id='id' :roundType='roundType' :roundInfo='roundInfo' />
              <v-btn v-if="roundType==='REGISTERED'" :disabled="status==='UPCOMING'" text color='black' @click='viewResults'><v-icon small>fas fa-eye</v-icon>&nbsp;&nbsp;Your Results</v-btn>
              <v-btn v-if="roundType==='UPCOMING'" text color='black' @click='goEvent(true)'><v-icon small>fas fa-eye</v-icon>&nbsp;&nbsp;Psych Sheet</v-btn>
              <!-- TODO: potentially add other buttons here as well for entering round, submitting times, etc... -->
            </v-col>
          </v-row>
        </v-list-item>
      </v-card>
    </v-hover>
  </div>
</template>

<script>
import utils from '@/modules/utils'
import RoundsService from '@/services/TPC/RoundsService'

import VideoLinkDialog from '@/components/TPC/VideoLinkDialog'
import Confirm from '@/components/TPC/Shared/Confirm'

export default {
  name: 'events-list-item',
  components: {
    VideoLinkDialog,
    Confirm,
  },
  data () {
    return {
      videoDialog: false
    }
  },
  methods: {
    async registerEvent () {
      let confirm = await this.$refs.confirm.open('Register', `<ul>
        <li>Once you register, you will find the round under the Your Rounds panel.</li>
        <li>If the qualifiers aren't open, we will send you a reminder email once they open.</li>
        <li>To qualify for the bracket stage, you must submit a video recording of your solves. You may also appear on the livestream if you qualify for the bracket stage.</li>
      </ul>
      <b>Confirm your registration?</b><br/>
      <b>Also, we're partnering with the American Cancer Society to help fundraise the fight against cancer. Since registration is free, if you're feeling generous, you can donate <a href='https://tiltify.com/@cuberslive/cuberslive-vs-cancer' target='_blank'>here</a>!</b>`, { color: 'green', width: 500, persistent: true })
      if (!confirm) return

      let resp = await RoundsService.registerRound({
        roundID: this.id + 'Rqual'
      })
      if (resp.data.error) {
        if (resp.data.message && resp.data.message.includes(`unique constraint "brackets_pkey"`)) {
          alert('You have already registered for this event')
        } else if (resp.data.error === 'notAuthenticated') {
          alert('You must log in to register.')
        } else if (resp.data.error === 'userBanned') {
          alert('User Banned: ' + resp.data.message)
        } else {
          alert('Error: ' + resp.data.error + ' - ' + resp.data.message)
        }
      } else {
        alert(`Successfully registered for ${this.name}. Once it is open you can find the event in the "Your Rounds" panel and compete.`)
        this.$router.go()
      }
    },
    competeRound () {
      this.$store.commit('setEventName', `${this.name}`)
      this.$router.push({path: `/tpc/compete/${this.id}`, query: {solverOrder: this.roundInfo.ord !== -1 ? this.roundInfo.ord : undefined}})
    },
    viewResults () {
      this.$store.commit('setEventName', `${this.name}`)
      this.$router.push({path: `/tpc/results/${this.id}/${this.roundInfo.profileid}o${this.roundInfo.ord}`})
    },
    goEvent (isPsychSheet) {
      this.$store.commit('setEventName', `${this.name}`)
      if (isPsychSheet) this.$router.push({path: `/tpc/event/${this.id}/psychsheet`})
      else this.$router.push({path: `/tpc/event/${this.id}`})
    }
  },
  props: {
    id: String,
    name: String,
    type: String,
    roundType: String,
    status: String,
    roundInfo: Object
  },
  computed: {
    cannotRegister () {
      return this.status !== 'OPEN' && this.status !== 'UPCOMING'
    },
    roundNameSuffix () {
      if (!this.roundInfo) return ''
      return utils.roundNameSuffix(this.roundInfo.roundid)
    }
  }
}
</script>

<style>
.v-list__tile {
  height: 88px
}
@media only screen and (max-width: 1080px) {
  .v-list__tile {
    height: 150px
  }
}
</style>
